import { NotificationHistory } from "@modules/roadLoad/model";
import { IUserNotification } from "@modules/notifications/model/INotifications";

import { INotificationIntegration } from "../Notifications";
import { ROADLOAD, PORTAL } from "../model/interface";

const useNotification = () => {
  const unifieldNotification = (
    roadLoadNotificationHistoryPortal: NotificationHistory | null,
    notificationsPortal: IUserNotification[]
  ): INotificationIntegration[] => {
    const unifieldListRoadLoad =
      roadLoadNotificationHistoryPortal?.rows?.map((item) => {
        return {
          id: item.id,
          title: item.title,
          message: item.message,
          read: item.read,

          sentAt: item.sentAt ?? "",
          subsidiaryRef: item.subsidiaryRef,
          type: ROADLOAD,
        };
      }) ?? [];

    const unifieldList = notificationsPortal.map((item) => {
      return {
        id: `${item.id}`,
        title: item.title,
        message: item.message,
        read: item.isRead,

        sentAt: item.createdAt ?? "",
        subsidiaryRef: item.targets.centers.join(","),
        type: PORTAL,
      };
    });

    return [...unifieldList, ...unifieldListRoadLoad];
  };

  return {
    state: {},
    action: {
      unifieldNotification,
    },
  };
};

export default useNotification;
